import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  imageUrl: string;
  rating: number;
  category: string;
  year: number;
  updateEpisode?: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function MovieCard({ id, title, imageUrl, rating, category, year, updateEpisode, isHot, isNew }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

        {isHot && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap">
            热门
          </div>
        )}
        {isNew && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap">
            新上线
          </div>
        )}

        <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 bg-black/60 rounded-md">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-background-50 text-xs font-medium">{rating}</span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-background-50 text-sm font-medium truncate mb-1">{title}</h3>
          <div className="flex items-center gap-2 text-xs text-background-300">
            <span className="bg-background-50/20 px-1.5 py-0.5 rounded whitespace-nowrap">{category}</span>
            <span>{year}</span>
            {updateEpisode && <span className="whitespace-nowrap">{updateEpisode}</span>}
          </div>
        </div>
      </div>
    </Link>
  );
}